import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import {
  CoachGroupsListScreenComponent
} from "../../page-modules/coach-groups-list/screen/coach-groups-list-screen.component";
import { CoachGuard } from "./route-guards/coach.guard";
import {
  PageNotFoundComponent
} from "../../shared/components/page-not-found/page-not-found.component";
import {
  AdminGroupsListScreenComponent
} from "../../page-modules/admin-groups-list/screen/admin-groups-list-screen.component";
import { GroupGuard } from "./route-guards/group.guard";
import {
  GroupDashboardScreenComponent
} from "../../page-modules/group-dashboard/screen/group-dashboard-screen.component";
import {
  ProfileComponent
} from "../../shared/pages/user-profile/profile/profile.component";
import {
  BehaviorTrackerWrapperComponent
} from "../../page-modules/behavior-tracker/screens/wrapper/behavior-tracker-wrapper.component";
import {
  MetricsScreenComponent
} from "../../page-modules/metrics/screen/metrics-screen.component";
import {
  SuperAdminSidenavComponent
} from "./sidenav/super-admin-sidenav.component";
import { SuperAdminGuard } from "./route-guards/super-admin.guard";
import { ClientGuard } from "./route-guards/client.guard";
import {
  ClientsListScreenComponent
} from "../../page-modules/clients-list/screen/clients-list-screen.component";
import { ClientAdminGuard } from "./route-guards/client-admin.guard";
import {
  InviteUserComponent
} from "../../page-modules/invite/screen/invite-user.component";
import {
  ClientDetailsScreenComponent
} from "../../page-modules/client-details/screen/client-details-screen/client-details-screen.component";
import {
  AddResourceScreenComponent
} from "../../page-modules/resources-hub/screens/add-resource-screen/add-resource-screen.component";
import {
  ViewResourceScreenComponent
} from "../../page-modules/resources-hub/screens/view-resource-screen/view-resource-screen.component";
import {
  ManageUsersScreenComponent
} from "../../page-modules/manage-users/screen/manage-users-screen.component";
import { MemberGuard } from "./route-guards/member.guard";
import {
  GroupDetailsScreenContainerComponent
} from "../../page-modules/group-details/container/group-details-screen-container.component";
import {
  ResourceListScreenComponent
} from "../../page-modules/resources-hub/screens/resource-list-screen/resource-list-screen.component";
import {
  ManageQuestionnairesScreenComponent
} from "../../page-modules/questionnaire/screens/manage-questionnaires-screen/manage-questionnaires-screen.component";
import {
  CreateSurveyScheduleScreenComponent
} from "../../page-modules/questionnaire/screens/create-survey-schedule-screen/create-survey-schedule-screen.component";
import {
  CreateSurveySendToScreenComponent
} from "../../page-modules/questionnaire/screens/create-survey-send-to-screen/create-survey-send-to-screen.component";
import {
  CreateSurveyFormScreenComponent
} from "../../page-modules/questionnaire/screens/create-survey-form-screen/create-survey-form-screen.component";
import {
  SessionDetailsComponent
} from "../../page-modules/sessions-list/components/session-details/session-details.component";
import {
  SessionsListTableComponent
} from "../../page-modules/sessions-list/components/sessions-list-table/sessions-list-table.component";
import {
  ProgressScreenComponent
} from "../../page-modules/progress/screen/progress-screen.component";
import {
  EditSurveyScreenComponent
} from "../../page-modules/questionnaire/screens/edit-survey-screen/edit-survey-screen.component";
import {
  NotificationsScreenComponent
} from "../../page-modules/notifications/screen/notifications-screen.component";
import {
  ReviewSurveyResponseScreenComponent
} from "../../page-modules/questionnaire/screens/review-survey-response-screen/review-survey-response-screen.component";
import {
  ReportsScreenComponent
} from "../../page-modules/reports/screens/reports-screen/reports-screen.component";
import {
  SurveyReviewScreenComponent
} from "../../page-modules/questionnaire/screens/survey-review-screen/survey-review-screen.component";
import {
  TakeSurveyScreenComponent
} from "../../page-modules/questionnaire/screens/take-survey-screen/take-survey-screen.component";
import {
  MyQuestionnairesListScreenComponent
} from "../../page-modules/questionnaire/screens/my-questionnaires-list-screen/my-questionnaires-list-screen.component";
import {
  ContractScreenComponent
} from "../../page-modules/contracts/screen/contract-screen.component";
import { MyJournalScreenComponent } from "../../page-modules/my-journal/screen/my-journal-screen/my-journal-screen.component";
import {
  FoodGuideListScreenComponent
} from "../../page-modules/food-guide-management/screen/food-guide-list-screen/food-guide-list-screen.component";

const superAdminRoutes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    outlet: 'sidenav',
    children: [
      {
        path: '',
        component: SuperAdminSidenavComponent,
      }
    ]
  },
  {
    path: 'dashboard',
    canActivate: [SuperAdminGuard],
    children: [
      {
        path: '',
        outlet: 'content',
        component: ClientsListScreenComponent,
      },
    ]
  },
  {
    path: 'manage-users',
    canActivate: [SuperAdminGuard],
    children: [
      {
        path: '',
        component: ManageUsersScreenComponent,
        outlet: 'content'
      },
    ]
  },
  {
    path: 'invite',
    canActivate: [SuperAdminGuard],
    children: [
      {
        path: '',
        component: InviteUserComponent,
        outlet: 'content'
      },
    ]
  },
  {
    path: 'my-profile',
    canActivate: [SuperAdminGuard],
    children: [
      {
        path: '',
        component: ProfileComponent,
        outlet: 'content'
      },
    ]
  },
  {
    path: 'manage-food-guide',
    canActivate: [SuperAdminGuard],
    children: [
      {
        path: '',
        outlet: 'content',
        component: FoodGuideListScreenComponent,
      },
    ]
  },
  {
    path: 'organization/add',
    canActivate: [SuperAdminGuard],
    children: [
      {
        path: '',
        outlet: 'content',
        component: ClientDetailsScreenComponent,
      },
    ]
  },
  {
    path: 'organization/:clientId',
    canActivate: [ClientGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        children: [
          {
            path: '',
            component: AdminGroupsListScreenComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'details',
        children: [
          {
            path: '',
            component: ClientDetailsScreenComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'questionnaires',
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'manage-questionnaires'
          },
          {
            path: 'manage-questionnaires',
            children: [
              {
                path: '',
                component: ManageQuestionnairesScreenComponent,
                outlet: 'content'
              }
            ]
          },
          {
            path: 'edit-questionnaire/:questionnaireId',
            children: [
              {
                path: '',
                outlet: 'content',
                component: EditSurveyScreenComponent,
              }
            ]
          },
          {
            path: 'review-questionnaire-response/:userId/:questionnaireId',
            children: [
              {
                path: '',
                outlet: 'content',
                component: ReviewSurveyResponseScreenComponent,
              }
            ]
          }
        ]
      },
      {
        path: '**',
        children: [
          {
            path: '',
            component: PageNotFoundComponent,
            outlet: 'content'
          }
        ]
      },
    ]
  },
  {
    path: 'organization-admin/:clientAdminId',
    canActivate: [ClientAdminGuard],
    children: [
      {
        path: '',
        redirectTo: 'profile',
        pathMatch: 'full'
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            component: ProfileComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'dashboard',
        children: [
          {
            path: '',
            component: AdminGroupsListScreenComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'organization-details',
        children: [
          {
            path: '',
            component: ClientDetailsScreenComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'manage-users',
        children: [
          {
            path: '',
            component: ManageUsersScreenComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'resource-hub',
        children: [
          {
            path: 'add-resource',
            children: [
              {
                path: '',
                component: AddResourceScreenComponent,
                outlet: 'content',
              }
            ]
          },
          {
            path: 'resource-details/:resourceId/:slug',
            children: [
              {
                path: '',
                component: ViewResourceScreenComponent,
                outlet: 'content',
              }
            ]
          },
          {
            path: 'edit-resource/:resourceId/:slug',
            children: [
              {
                path: '',
                component: AddResourceScreenComponent,
                outlet: 'content',
              }
            ]
          },
          {
            path: 'preview-resource/:resourceId/:slug',
            children: [
              {
                path: '',
                component: ViewResourceScreenComponent,
                outlet: 'content',
              }
            ]
          },
          {
            path: '',
            children: [
              {
                path: '',
                component: ResourceListScreenComponent,
                outlet: 'content',
              }
            ]
          },
        ]
      },
      {
        path: '**',
        children: [
          {
            path: '',
            component: PageNotFoundComponent,
            outlet: 'content'
          }
        ]
      },
    ]
  },
  {
    path: 'coach/:coachId',
    canActivate: [CoachGuard],
    children: [
      {
        path: '',
        redirectTo: 'profile',
        pathMatch: 'full'
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            component: ProfileComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'groups',
        children: [
          {
            path: '',
            component: CoachGroupsListScreenComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'notifications',
        children: [
          {
            path: '',
            component: NotificationsScreenComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'manage-users',
        children: [
          {
            path: '',
            component: ManageUsersScreenComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'resource-hub',
        children: [
          {
            path: 'add-resource',
            children: [
              {
                path: '',
                component: AddResourceScreenComponent,
                outlet: 'content',
              }
            ]
          },
          {
            path: 'resource-details/:resourceId/:slug',
            children: [
              {
                path: '',
                component: ViewResourceScreenComponent,
                outlet: 'content',
              }
            ]
          },
          {
            path: 'edit-resource/:resourceId/:slug',
            children: [
              {
                path: '',
                component: AddResourceScreenComponent,
                outlet: 'content',
              }
            ]
          },
          {
            path: 'preview-resource/:resourceId/:slug',
            children: [
              {
                path: '',
                component: ViewResourceScreenComponent,
                outlet: 'content',
              }
            ]
          },
          {
            path: '',
            children: [
              {
                path: '',
                component: ResourceListScreenComponent,
                outlet: 'content',
              }
            ]
          },
        ]
      },
      {
        path: '**',
        children: [
          {
            path: '',
            component: PageNotFoundComponent,
            outlet: 'content'
          }
        ]
      },
    ]
  },
  {
    path: 'group/create',
    canActivate: [SuperAdminGuard],
    children: [
      {
        path: '',
        outlet: 'content',
        component: GroupDetailsScreenContainerComponent,
      },
    ]
  },
  {
    path: 'group/duplicate',
    canActivate: [SuperAdminGuard],
    children: [
      {
        path: '',
        outlet: 'content',
        component: GroupDetailsScreenContainerComponent,
      },
    ]
  },
  {
    path: 'group/:groupId',
    canActivate: [GroupGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        children: [
          {
            path: '',
            component: GroupDashboardScreenComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'sessions',
        children: [
          {
            path: '',
            component: SessionsListTableComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'details',
        children: [
          {
            path: '',
            component: GroupDetailsScreenContainerComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: "sessions/:sessionId",
        canActivate: [GroupGuard],
        children: [
          {
            path: "details",
            children: [
              {
                path: "",
                component: SessionDetailsComponent,
                outlet: "content"
              },
            ]
          },
        ]
      },
      {
        path: 'questionnaires',
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'manage-questionnaires'
          },
          {
            path: 'manage-questionnaires',
            children: [
              {
                path: '',
                component: ManageQuestionnairesScreenComponent,
                outlet: 'content'
              }
            ]
          },
          {
            path: 'edit-questionnaire/:questionnaireId',
            children: [
              {
                path: '',
                outlet: 'content',
                component: EditSurveyScreenComponent,
              }
            ]
          },
          {
            path: 'review-questionnaire-response/:userId/:questionnaireId',
            children: [
              {
                path: '',
                outlet: 'content',
                component: ReviewSurveyResponseScreenComponent,
              }
            ]
          }
        ]
      },
      {
        path: "**",
        children: [
          {
            path: "",
            component: PageNotFoundComponent,
            outlet: 'content'
          }
        ]
      },
    ]
  },
  {
    path: 'member/:memberId',
    canActivate: [MemberGuard],
    children: [
      {
        path: '',
        redirectTo: 'profile',
        pathMatch: 'full'
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            component: ProfileComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'behavior-tracker',
        children: [
          {
            path: '',
            component: BehaviorTrackerWrapperComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'my-journal',
        children: [
          {
            path: '',
            children: [
              {
                path: '',
                component: MyJournalScreenComponent,
                outlet: 'content'
              }
            ]
          }
        ]
      },
      {
        path: 'metrics',
        children: [
          {
            path: '',
            component: MetricsScreenComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'progress',
        children: [
          {
            path: '',
            component: ProgressScreenComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'notifications',
        children: [
          {
            path: '',
            component: NotificationsScreenComponent,
            outlet: 'content'
          },
        ]
      },
      {
        path: 'resource-hub',
        children: [
          {
            path: 'add-resource',
            children: [
              {
                path: '',
                component: AddResourceScreenComponent,
                outlet: 'content',
              }
            ]
          },
          {
            path: 'resource-details/:resourceId/:slug',
            children: [
              {
                path: '',
                component: ViewResourceScreenComponent,
                outlet: 'content',
              }
            ]
          },
          {
            path: 'edit-resource/:resourceId/:slug',
            children: [
              {
                path: '',
                component: AddResourceScreenComponent,
                outlet: 'content',
              }
            ]
          },
          {
            path: 'preview-resource/:resourceId/:slug',
            children: [
              {
                path: '',
                component: ViewResourceScreenComponent,
                outlet: 'content',
              }
            ]
          },
          {
            path: 'resources-list',
            children: [
              {
                path: '',
                component: ResourceListScreenComponent,
                outlet: 'content',
              }
            ]
          },
        ]
      },
      {
        path: 'contract',
        children: [
          {
            path: '',
            component: ContractScreenComponent,
            outlet: 'content',
          }
        ]
      },
      {
        path: '**',
        children: [
          {
            path: '',
            component: PageNotFoundComponent,
            outlet: 'content'
          }
        ]
      },
    ]
  },
  {
    path: 'resource-hub',
    children: [
      {
        path: 'add-resource',
        children: [
          {
            path: '',
            component: AddResourceScreenComponent,
            outlet: 'content',
          }
        ]
      },
      {
        path: 'resource-details/:resourceId/:slug',
        children: [
          {
            path: '',
            component: ViewResourceScreenComponent,
            outlet: 'content',
          }
        ]
      },
      {
        path: 'edit-resource/:resourceId/:slug',
        children: [
          {
            path: '',
            component: AddResourceScreenComponent,
            outlet: 'content',
          }
        ]
      },
      {
        path: 'preview-resource/:resourceId/:slug',
        children: [
          {
            path: '',
            component: ViewResourceScreenComponent,
            outlet: 'content',
          }
        ]
      },
      {
        path: 'resources-list',
        children: [
          {
            path: '',
            component: ResourceListScreenComponent,
            outlet: 'content',
          }
        ]
      },
    ]
  },
  {
    path: 'questionnaires',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'manage-questionnaires'
      },
      {
        path: 'manage-questionnaires',
        children: [
          {
            path: '',
            component: ManageQuestionnairesScreenComponent,
            outlet: 'content'
          }
        ]
      },
      {
        path: 'create-questionnaire-schedule',
        children: [
          {
            path: '',
            outlet: 'content',
            component: CreateSurveyScheduleScreenComponent,
          }
        ]
      },
      {
        path: 'create-questionnaire-send-to/:questionnaireId',
        children: [
          {
            path: '',
            outlet: 'content',
            component: CreateSurveySendToScreenComponent,
          }
        ]
      },
      {
        path: 'create-questionnaire-form/:questionnaireId',
        children: [
          {
            path: '',
            outlet: 'content',
            component: CreateSurveyFormScreenComponent,
          }
        ]
      },
      {
        path: 'edit/create-questionnaire-schedule/:questionnaireId',
        children: [
          {
            path: '',
            outlet: 'content',
            component: CreateSurveyScheduleScreenComponent,
          }
        ]
      },
      {
        path: 'edit/create-questionnaire-send-to/:questionnaireId',
        children: [
          {
            path: '',
            outlet: 'content',
            component: CreateSurveySendToScreenComponent,
          }
        ]
      },
      {
        path: 'edit/create-questionnaire-form/:questionnaireId',
        children: [
          {
            path: '',
            outlet: 'content',
            component: CreateSurveyFormScreenComponent,
          }
        ]
      },
      {
        path: 'edit-questionnaire/:questionnaireId',
        children: [
          {
            path: '',
            outlet: 'content',
            component: EditSurveyScreenComponent,
          }
        ]
      },
      {
        path: 'review-questionnaire-response/:userId/:questionnaireId',
        children: [
          {
            path: '',
            outlet: 'content',
            component: ReviewSurveyResponseScreenComponent,
          }
        ]
      },
      {
        path: 'my-questionnaires',
        children: [
          {
            path: '',
            component: MyQuestionnairesListScreenComponent,
            outlet: 'content',
          }
        ]
      },
      {
        path: 'take-questionnaires/:questionnaireId',
        children: [
          {
            path: '',
            component: TakeSurveyScreenComponent,
            outlet: 'content',
          }
        ]
      },
      {
        path: 'survey-questionnaires/:questionnaireId',
        children: [
          {
            path: '',
            component: SurveyReviewScreenComponent,
            outlet: 'content',
          }
        ]
      },
    ]
  },
  {
    path: 'notifications',
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            component: NotificationsScreenComponent,
            outlet: 'content'
          }
        ]
      },
    ]
  },
  {
    path: 'reports',
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            component: ReportsScreenComponent,
            outlet: 'content'
          }
        ]
      },
    ]
  },
  {
    path: '**',
    children: [
      {
        path: '',
        component: PageNotFoundComponent,
        outlet: 'content'
      }
    ]
  },
]

@NgModule({
  imports: [RouterModule.forChild(superAdminRoutes)],
  exports: [RouterModule]
})
export class SuperAdminRouting {
}
